module.exports = __webpack_public_path__ + "static/media/chaleco-2.47984d30.png";